import { FC } from 'react'

import { useAtom, useAtomValue } from 'jotai'

import { DeflectionWithPromoActiveModal } from '../DeflectionWithActivePromoModal/DeflectionWithActivePromoModal'
import { changePlanSuccessModalAtom } from 'src/atoms/modals/changePlanSuccessModalAtom.atom'
import { deflectionWithActivePromoModalAtom } from 'src/atoms/modals/deflectionWithPromoActiveModal.atom'
import { membershipModalAtom } from 'src/atoms/modals/membershipModal.atom'
import { userOnboardingModalAtom } from 'src/atoms/modals/userOnboardingModal.atom'
import { downloadAppModalAtom } from 'src/atoms/downloadAppModal.atom'
import { useChangePlanModal } from 'src/hooks/useChangePlanModal'
import { MembershipModal } from 'src/pages/membership/MembershipModal'
import { ChangePlanModal } from 'src/pages/myPlan/components/ChangePlanModal/ChangePlanModal'
import { ChangePlanSuccessModalOverlay } from 'src/pages/myPlan/components/ChangePlanSuccessModal/ChangePlanSuccessModalOverlay'
import { getCookie } from '../../utils/browserCookies'
import { IMPERSONATION_COOKIE_NAME } from '../../constants/application'
import { ImpersonationPanel } from '../ImpersonationPanel/ImpersonationPanel'
import { UserOnboardingModal } from '../Modals/UserOnboardingModal/UserOnboardingModal'
import { DownloadAppModal } from '../../components/DownloadAppModal/DownloadAppModal'
import { rateMealsModalAtom } from 'src/atoms/modals/rateMealsModal.atom'
import { RateMealsModal } from '../RateMealsModal/RateMealsModal'
import { connectCalendarHelpModalAtom } from 'src/atoms/modals/connectCalendarHelpModal.atom'
import { ConnectCalendarHelpModal } from '../ConnectCalendarHelpModal/ConnectCalendarHelpModal'

const Global: FC = () => {
  const impersonationCookie = getCookie(IMPERSONATION_COOKIE_NAME)

  const { isOpen: changePlanModalOpen } = useChangePlanModal()
  const { isOpen: isDeflectionWithActivePromoModalOpen } = useAtomValue(
    deflectionWithActivePromoModalAtom
  )
  const [changePlanSuccessModal] = useAtom(changePlanSuccessModalAtom)
  const { isOpen: isMembershipModalOpen } = useAtomValue(membershipModalAtom)
  const { isOpen: isUserOnboardingModalOpen } = useAtomValue(
    userOnboardingModalAtom
  )
  const { isOpen: downoadAppModalOpen } = useAtomValue(downloadAppModalAtom)
  const { isOpen: rateMealsModalOpen } = useAtomValue(rateMealsModalAtom)
  const { isOpen: connectCalendarHelpModalOpen } = useAtomValue(
    connectCalendarHelpModalAtom
  )
  return (
    <>
      {impersonationCookie && <ImpersonationPanel />}
      {changePlanSuccessModal.isOpen && <ChangePlanSuccessModalOverlay />}
      {changePlanModalOpen && <ChangePlanModal />}
      {isDeflectionWithActivePromoModalOpen && (
        <DeflectionWithPromoActiveModal />
      )}
      {isMembershipModalOpen && <MembershipModal />}
      {isUserOnboardingModalOpen && <UserOnboardingModal />}
      {downoadAppModalOpen && <DownloadAppModal />}
      {rateMealsModalOpen && <RateMealsModal />}
      {connectCalendarHelpModalOpen && <ConnectCalendarHelpModal />}
    </>
  )
}

export default Global
